import { render } from "./pubDataTable.vue?vue&type=template&id=8fede3ca&scoped=true"
import script from "./pubDataTable.vue?vue&type=script&lang=js"
export * from "./pubDataTable.vue?vue&type=script&lang=js"

import "./pubDataTable.vue?vue&type=style&index=0&id=8fede3ca&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3586\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fede3ca"]])

export default __exports__